import { useState } from 'react';
import MainLogo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router';
import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';

export default function RegisterWrestler() {
    // const { id } = useParams();
    const [isSuccess /* setIsSuccess */] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/auth`);
    };

    // const performPayment = async (record) => {
    //     // setIsPayLoading(true)
    //     const payload = {
    //         lineItems: [
    //             {
    //                 price_data: {
    //                     currency: 'usd',
    //                     product_data: {
    //                         name: `${record.firstName} ${record.lastName} joining in ${record.school.schoolName}`,
    //                     },
    //                     unit_amount: record.fee * 100,
    //                 },
    //                 quantity: 1,
    //             },
    //         ],
    //         payment_intent_data: {
    //             metadata: {
    //                 payment_type: 'school_joining_fee',
    //                 schoolId: record.schoolId,
    //                 userIds: record?.studentId,
    //             },
    //         },
    //     };

    //     try {
    //         const response = await stripeService.doStripePayment(payload);
    //         window.location.href = response.url;
    //     } catch (error) {
    //         console.log('error', error);
    //     } finally {
    //         // setIsPayLoading(false)
    //     }
    // };

    return (
        <>
            <Stack
                sx={{
                    height: 'min(10vh, 100px)',
                    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
                    textAlign: 'center',
                    padding: 1,
                    background: 'linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 9,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img style={{ height: '100%', width: 'auto' }} src={MainLogo} />
            </Stack>

            {isSuccess ? (
                <>
                    <Alert severity="success">
                        <AlertTitle>Wrestler Registration Successfully Completed</AlertTitle>
                        <Typography>
                            {`If you've already provided your email, please check your inbox 
        for further instructions on creating your password. Alternatively, reach out to your
         coach for additional assistance. Feel free to close this window.`}
                        </Typography>
                        <Button onClick={() => handleNavigate()}>Sign In</Button>;
                    </Alert>
                </>
            ) : (
                <Stack
                    flexDirection={'column'}
                    justifyContent={'center'}
                    maxWidth={'700px'}
                    sx={{
                        boxShadow: '0px 6px 8px 0px rgba(0, 0, 0, 0.15)',
                        background: '#fff',
                        borderRadius: 8,
                        marginTop: { xs: 'min(1vh, 20px)', md: 'min(10vh, 100px)' },
                        marginX: 'auto',
                        padding: '32px 32px 5px 32px',
                    }}
                >
                    <div className="reg-form-content">
                        <Typography variant="h3">Wrestler Registration</Typography>
                        <Typography>
                            Fill out this form and click on the submit button to send these details
                            to your coach.
                        </Typography>
                    </div>

                    <hr />

                    {/* <AddWrestlerForm
                        onSuccess={() => setIsSuccess(true)}
                        // schoolId={id}
                        // registerWrestlerItSelf={true}
                        // callBack={(payload) => {
                        //     console.log('payload', payload);
                        //     if (payload.fee === 0) {
                        //         setIsSuccess(true);
                        //         return;
                        //     }
                        //     performPayment(payload);
                        // }}
                    /> */}
                </Stack>
            )}
        </>
    );
}
